export default {
    listing: state => state.info.listing,
    moreLink: state => state.info.moreLink,
    baseUrl: state => state.info.baseUrl,
    baseListingAddr: state => state.info.baseListingAddr,
    dataType: state => state.info.dataType,
    forMoreData: state => state.info.forMoreData
};
